module.exports = __webpack_public_path__ + "img/qrcode.29cf8927.jpg";